// @flow

export type LoginInfoType = {|
  email: string,
  password: string,
|};

export type LoginSuccessType = {|
  token: string,
  externalId: string,
|};

export type AuthActionType =
  | {|
      type: 'LOG_OUT',
    |}
  | {|
      type: 'RESET_CUSTOMER_DATA',
    |}
  | {|
      type: 'RESET_PASSWORD',
      payload: {| email: string |},
    |}
  | {|
      type: 'CHANGE_PASSWORD',
      payload: {| newPassword: string, oldPassword: string |},
    |};

export type LoginActionType =
  | {|
      type: 'LOGIN_DURING_ACTIVATE',
      payload: LoginInfoType,
    |}
  | {|
      type: 'LOGIN_DURING_SIGNUP',
      payload: LoginInfoType,
    |}
  | {|
      type: 'LOGIN_REQUEST',
      payload: LoginInfoType & { redirectPath: string },
    |}
  | {|
      type: 'SIGN_IN_SUCCESS',
      payload: LoginSuccessType,
    |}
  | {|
      type: 'RESET_PASSWORD_CONFIRMATION',
      payload: {|
        password: string,
      |},
    |}
  | {|
      type: 'SET_DEVICE_ID',
      payload: {|
        deviceId: string,
      |},
    |}
  | {|
      type: 'SUBMIT_OTP',
      payload: {| otpCode: string |},
    |}
  | {|
      type: 'RESEND_LOGIN_OTP',
    |};

export function loginDuringActivate(payload: LoginInfoType): LoginActionType {
  return { type: 'LOGIN_DURING_ACTIVATE', payload };
}

export function loginDuringSignUp(payload: LoginInfoType): LoginActionType {
  return { type: 'LOGIN_DURING_SIGNUP', payload };
}

export function loginRequest(payload: LoginInfoType & { redirectPath: string }): LoginActionType {
  return { type: 'LOGIN_REQUEST', payload };
}

export function signInSuccess(payload: LoginSuccessType): LoginActionType {
  return {
    type: 'SIGN_IN_SUCCESS',
    payload,
  };
}

export const resetPasswordRequest = (formValues: {| password: string |}): LoginActionType => {
  return {
    type: 'RESET_PASSWORD_CONFIRMATION',
    payload: formValues,
  };
};

export const logOut = (): AuthActionType => ({
  type: 'LOG_OUT',
});

export const resetCustomerData = (): AuthActionType => ({
  type: 'RESET_CUSTOMER_DATA',
});

export const resetPassword = ({ email }: any): AuthActionType => ({
  type: 'RESET_PASSWORD',
  payload: { email },
});

export const changePassword = ({ newPassword, oldPassword }: any): AuthActionType => ({
  type: 'CHANGE_PASSWORD',
  payload: { newPassword, oldPassword },
});

export const setDeviceId = (deviceId: string): LoginActionType => ({
  type: 'SET_DEVICE_ID',
  payload: { deviceId },
});
